import { takeLatest, put, all, call } from 'redux-saga/effects';
import LoanCardReportActionTypes from './loan-card-report.types';
import { memberLoanCardReport } from './loan-card-report.service';
import {
	getMemberLoanCardSuccess,
	getMemberLoanCardFailure,
	getMemberLoanCardResponseChanged,
} from './loan-card-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/****************  GET PARTICULAR MEMBER LOAN CARD START ********************** */
export function* getMemberLoanCard({ payload }: any) {
	try {
		const key = 'GetLoanDetailsForParticularMemberKey';
		const jsonData = {
			CompanyID: payload.companyID,
			FunderID: '0',
			DatabaseName: payload.databaseName,
			LoanIndexID: payload.loanIndexID,
			MemberID: payload.memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberLoanCardReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberLoanCardFailure(responseData.data));
		} else {
			yield put(getMemberLoanCardSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberLoanCardFailure(error));
	}
}

export function* resetGetMemberLoanCardListResponse() {
	yield put(getMemberLoanCardResponseChanged());
}

export function* onGetMemberLoanCardDetails() {
	yield takeLatest(LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_START, getMemberLoanCard);
}

export function* onGetMemberLoanCardResponseReset() {
	yield takeLatest(
		LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_RESPONSE_RESET,
		resetGetMemberLoanCardListResponse,
	);
}
/****************  GET PARTICULAR MEMBER LOAN CARD END ********************** */

export function* loanCardReportSaga() {
	yield all([call(onGetMemberLoanCardDetails), call(onGetMemberLoanCardResponseReset)]);
}
